"use client";

import React from "react";
import { useState } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import PropTypes from "prop-types";
import { Info, CheckCircle, AlertTriangle, XCircle, X as CloseIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const ICONS = {
  info: Info,
  success: CheckCircle,
  warning: AlertTriangle,
  error: XCircle,
};

const VARIANT_CLASSES = {
  info: "bg-blue-50 text-blue-800 border-blue-200",
  success: "bg-green-50 text-green-800 border-green-200",
  warning: "bg-yellow-50 text-yellow-800 border-yellow-200",
  error: "bg-red-50 text-red-800 border-red-200",
};

export default function SiteAlert({ type = "info", title, description, dismissible = false }) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  const Icon = ICONS[type] || Info;

  return (
    <Alert className={cn("border flex items-start gap-2 p-2 rounded-md", VARIANT_CLASSES[type])}>
      <Icon className="h-5 w-5 " />
      <div className="flex-1">
        {title && <AlertTitle className="font-semibold">{title}</AlertTitle>}
        {description && <AlertDescription>{description}</AlertDescription>}
      </div>
      {dismissible && (
        <button
          onClick={() => setVisible(false)}
          className="ml-4 mt-1 text-inherit hover:opacity-70"
          aria-label="Cerrar alerta"
        >
          <CloseIcon className="h-4 w-4" />
        </button>
      )}
    </Alert>
  );
}
SiteAlert.propTypes = {
  type: PropTypes.oneOf(["info", "success", "warning", "error"]),
  title: PropTypes.string,
  description: PropTypes.string,
  dismissible: PropTypes.bool,
};
